import { PageHeader } from "./layoutChrome";
import { VISOR_MODULE_BREADCRUMB_ROOT } from "@/modules/workModuleCore";
import AccountingViewer from "@/components/accounting/AccountingViewer";
import { BookOpen } from "lucide-react";

/**
 * Visor de contabilidad — inventario unificado de CFDI (Fase 3).
 */
export default function Contabilidad() {
  return (
    <div className="min-h-screen">
      <PageHeader
        title="Mis CFDI"
        subtitle="Contabilidad: consulta paginada de la colección cfdis (manual, carpeta y sincronización SAT). No muestra bitácora de sync."
        breadcrumb={[VISOR_MODULE_BREADCRUMB_ROOT, "Mis CFDI"]}
      />
      <div className="p-8 max-w-[1400px] mx-auto">
        <div className="bg-white rounded-md border border-slate-200 p-5 shadow-sm">
          <div className="flex items-center gap-2 mb-4 text-[#0F2D5C]">
            <BookOpen className="h-5 w-5" aria-hidden />
            <p className="text-sm font-medium m-0">
              Tabla maestra de comprobantes — use filtros y paginación para explorar inventarios grandes.
            </p>
          </div>
          <AccountingViewer />
        </div>
      </div>
    </div>
  );
}
